import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, AfterViewInit, OnChanges, ViewChildren, ViewEncapsulation, ViewChild, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router} from "@angular/router";
import { ProductsService } from "../../../../Common/Services/products.service";
import { IFinish} from "../../../../Common/Interfaces/IFinish";
import { IVariantGroupingType} from "../../../../Common/Interfaces/IVariantGroupingType";
import { Location } from "@angular/common";
import { Scene7Helper} from "../../../../Common/helpers/scene7.helper";
import {ICategoryBrowseFilterOptions} from "../../../../Common/Interfaces/ICategoryBrowseFilterOptions";
import {IStyle} from "../../../../Common/Interfaces/IStyle";
import { IApiResponse} from "../../../../Common/Interfaces/IApiResponse";
import {Subscribable} from "rxjs/Observable";
import {GeneralHelpers} from "../../../../Common/helpers/general.helper";

@Component({
  selector: 'kws-filter-bar',
  templateUrl: './filter-bar.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FilterBarComponent implements OnInit, AfterViewInit, AfterViewChecked, OnChanges {
  @Input() variantGroupingTypes: IVariantGroupingType[];
  @Input() variantGroupingTypesSingle: IVariantGroupingType;
  @Input() finishes: IFinish[];
  @Input() defaultFinish: string;
  @Input() finishDisplayTitle: string = 'Finish';
  @Input() groupBy: string;
  @Input() cat: string;
  @Input() secondaryCat: string;
  @Input() type: string;
  @Input() subtype: string;
  @Input() isShowingAllFinishes: boolean = false;
  @ViewChild('radio_elem') radioElement;
  @ViewChild('label_elem') labelElement;
  @ViewChild('finish_elem') finishElement;
  Scene7Helper: Scene7Helper;
  isSelected: boolean;
  selectedFinishTitle: string;
  selectedFinishSlug: string;
  finishkey: string = "finish";
  styles: IStyle[];
  returnText: string;
  currentParams: ICategoryBrowseFilterOptions;
  elem;

  constructor(private location: Location, public cd: ChangeDetectorRef, private route: ActivatedRoute, public productsService: ProductsService, elementRef: ElementRef) {
    this.elem = elementRef;
    this.currentParams = this.productsService.getFilterOptionParams();
  }

  ngOnInit() {

  }

  ngAfterViewInit(){

  }

  ngAfterViewChecked(){

  }

  ngOnChanges(){
    this.setupSelectedFinishBasedonParams();
  }

  getFinishThumbnail(finish: IFinish): string {
    return Scene7Helper.imagePath(finish.thumbnail, 'Kwikset', 'KWSFinishThumb');
  }

  showFinishName(event) {
    this.returnText = this.finishElement.nativeElement.innerText;
    let finishName = event.currentTarget.getAttribute('data-title');
    this.selectedFinishTitle = finishName;
  }

  returnOrigFinishName(event) {
    this.selectedFinishTitle = this.returnText;
  }

  setActiveFinish(finishes, index, event){
    for(let nextFinish of finishes) {
      nextFinish.isSelected = false;
    }

    finishes[index].isSelected = true;
    this.cd.detectChanges();
    this.selectedFinishTitle = finishes[index].title;
    this.selectedFinishSlug = finishes[index].slug;
    console.log(this.selectedFinishSlug);
  }

  setupSelectedFinishBasedonParams(){
    this.route.queryParams.subscribe(params => {
      //Here we're checking to see if the current tab is set in the params
      //if it is then set the currently selected item
      let finishes = this.finishes;
      if(finishes) {
        this.selectedFinishTitle = '';
        this.selectedFinishSlug = '';
        this.returnText = '';

        for(let i = 0; i < finishes.length; i++) {
          finishes[i].isSelected = false;
        }

        if (this.isShowingAllFinishes && !params.finish) {
          this.selectedFinishTitle = 'All';
          this.returnText = this.selectedFinishTitle;
          this.cd.detectChanges();
          return;
        }

        for(let i = 0; i < finishes.length; i++) {
          if(params.finish == finishes[i].slug || (!params.finish && finishes[i].slug == this.defaultFinish)) {
            finishes[i].isSelected = true;
            this.cd.detectChanges();
            this.selectedFinishTitle = finishes[i].title;
          }
        }

        //if params are not set and there is no default finish specified set the first finish as active
        if(!params.finish && !this.defaultFinish) {
          finishes[0].isSelected = true;
          this.cd.detectChanges();
          this.selectedFinishTitle = finishes[0].title;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/CategoryBrowsing/src/app/filter-bar/filter-bar.component.ts